import { axiosAjax } from '@app/src/config/axios';
import { BrandVehicleModel } from '@app/src/views/StepOne/form/models/brandVehicle';
import { hydrateData } from './hydrators';
import { isClientEnv } from '@app/src/utils/validations';

export const brandVehicleService = {
  async get(vehicleId: number, brandName: string, flag?: string): Promise<BrandVehicleModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      let uri = process.env.API_VEHICLE_BRAND
                .replace(':vehicleId', '' + vehicleId)
                .replace(':brandName', brandName);
      if (flag === 'all') {
        uri = process.env.API_VEHICLE_BRAND_ALL
                .replace(':brandName', brandName);
      }
      const { data } = await axiosAjax.get(uri, config);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
